// src/pages/HomePage.jsx
import React from 'react'; // 1. Importa useState y useEffect

// Importa el componente del popup


// Importa el resto de tus componentes de sección
import HeroCarousel from '../components/HeroCarousel';
import AboutSection from '../components/AboutSection';
import FactsSection from '../components/FactsSection';
import FeaturesSection from '../components/FeaturesSection';
import ServicesSection from '../components/ServicesSection';
import QuoteFormSection from '../components/QuoteFormSection';
import TestimonialSection from '../components/TestimonialSection';

function HomePage() {
  // 2. Crea un estado para controlar si el popup se muestra o no



  return (
    <>
      {/* 5. Renderiza el popup condicionalmente */}
      {/*/>}

      {/* El resto de tu página se renderiza debajo */}
      <HeroCarousel />
      <AboutSection />
      <FactsSection />
      <FeaturesSection />
      <ServicesSection />
      <QuoteFormSection />
      <TestimonialSection />
    </>
  );
}

export default HomePage;